// extracted by mini-css-extract-plugin
module.exports = {"image":"OtherImagesList_image__2tABv"};